import Vue from 'vue'
import App from './App.vue'
import HLoading from './components/loading/index'  // Loading
Vue.use(HLoading)
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js